<div class="cookie-consent" *ngIf="!consentAccepted" tabindex="0">
  <div class="cookie-consent__container">
    <p>
      We use cookies on this site to enhance your user experience and to help us understand how you use our site. 
      <a href="https://amilearn.ca/terms#cookies" role="link" target="_blank">Read our terms and conditions</a>  to learn more.
    </p>

    <button
      class="btn btn-secondary-small"
      type="button"
      (click)="onAccept()"
    >
      Accept
    </button>
  </div>
</div>
